// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2TmDb","head":"Table_head__NLYXQ","col":"Table_col__3vEAo"};